import React, { useState, useRef } from "react";
import ShareScopeEditDropDown from "./ShareScopeEditDropDown";
import SharedScopeSpecificSelectionTable from "./SharedScopeSpecificSelectionTable";

const Icon = ({ name = "edit" }) => {
    const icons = {
        edit: (
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M6.7002 2.11423H2.03353C1.67991 2.11423 1.34077 2.2547 1.09072 2.50475C0.840671 2.7548 0.700195 3.09394 0.700195 3.44756V12.7809C0.700195 13.1345 0.840671 13.4737 1.09072 13.7237C1.34077 13.9738 1.67991 14.1142 2.03353 14.1142H11.3669C11.7205 14.1142 12.0596 13.9738 12.3097 13.7237C12.5597 13.4737 12.7002 13.1345 12.7002 12.7809V8.11423M11.7002 1.11423C11.9654 0.849009 12.3251 0.700012 12.7002 0.700012C13.0753 0.700012 13.435 0.849009 13.7002 1.11423C13.9654 1.37944 14.1144 1.73915 14.1144 2.11423C14.1144 2.4893 13.9654 2.84901 13.7002 3.11423L7.36686 9.44756L4.7002 10.1142L5.36686 7.44756L11.7002 1.11423Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        )
    };
    return icons[name] || icons.edit;
};

const SharedScopeEdit = ({ selectedRow, onUpdateSuccess, from }) => {
    // from --> topic , learningpath
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const selectorRef = useRef(null);
    return (
        <div className="sharedScopeContainer">
            <div ref={selectorRef} className={`sharedScopeEditSelector${dropdownOpen ? ' active' : ''}`} onClick={() => setDropdownOpen(!dropdownOpen)}>
                <Icon />
            </div>

            {dropdownOpen && (
                <ShareScopeEditDropDown selectedRow={selectedRow} onUpdateSuccess={onUpdateSuccess} setDropdownOpen={setDropdownOpen} setOpenModal={setOpenModal} from={from} anchorRef={selectorRef} />
            )}

            {openModal && (
                <SharedScopeSpecificSelectionTable selectedRow={selectedRow} onUpdateSuccess={onUpdateSuccess} openModal={openModal} setOpenModal={setOpenModal} from={from}/>
            )}
        </div>
    );
};

export default SharedScopeEdit;
